var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditProdutoImobiliario(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_838_5280",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_838_5280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 24V22H22.5V24H2.5ZM5.5 19V16.6346L14.3192 7.85387L16.6462 10.1808L7.86538 19H5.5ZM17.5404 9.1962L15.2135 6.90772L16.3596 5.76157C16.543 5.57439 16.7699 5.48176 17.0404 5.48367C17.3109 5.48561 17.5378 5.57824 17.7212 5.76157L18.6481 6.6885C18.8314 6.87183 18.9295 7.09779 18.9423 7.36637C18.9551 7.63497 18.8699 7.86286 18.6866 8.05005L17.5404 9.1962Z",
    fill: "#B8B9BA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProdutoImobiliario);
export default __webpack_public_path__ + "static/media/edit-produto-imobiliario.a096d5a7a2ba5049977ccf0b418333a3.svg";
export { ForwardRef as ReactComponent };